import { AllPlatform } from "../../../components/Contents/seecharleepage/AllPlatform";
import { Footer } from "../../../components/footers/Footer";
import { FooterBanner } from "../../../components/footers/FooterBanner";
import { HomeHeader } from "../../../components/headers/HomeHeader";
import { SeeCharleeHero } from "../../../components/heros/SeeCharleeHero";

import SplitType from "split-type";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import TextPlugin from "gsap/TextPlugin";
import { useGSAP } from "@gsap/react";
import { useRef } from "react";
import { RiteCharleeHero } from "../../../components/heros/RiteCharleeHero";

gsap.registerPlugin(useGSAP, ScrollTrigger, TextPlugin);
export const RiteCharlee = () => {
  const riteCharleeRef = useRef();
  useGSAP(
    () => {
      const riteCharleeHead = new SplitType(".riteCharlee-head", {
        types: "lines, words, chars",
        tagName: "h5",
      });
      const riteCharleeText = new SplitType(".riteCharlee-explanation", {
        types: "lines",
        tagName: "p",
      });
      const charleeAvata = gsap.utils.toArray(".riteCharlee-dashboard");

      const riteCharleeTimeline = gsap.timeline();
      riteCharleeTimeline.fromTo(
        riteCharleeHead.chars,
        {
          y: "50%",
          opacity: 0,
        },
        {
          y: "0",
          opacity: 1,
          stagger: 0.05,
          duration: 0.5,
          ease: "power4.out",
        },
        "+=0"
      );
      riteCharleeTimeline.fromTo(
        riteCharleeText.lines,
        {
          y: "-50%",
          opacity: 0,
        },
        {
          y: "0",
          opacity: 1,
          stagger: 0.1,
          duration: 0.5,
          ease: "power4.out",
        },
        "+=0"
      );

      gsap.fromTo(
        charleeAvata[0],
        { opacity: 0, x: "300%" },
        { opacity: 1, x: "0", duration: 1.5 }
      );
      // gsap.utils.toArray('.seecharlee-logoText')
    },
    {
      scope: riteCharleeRef,
    }
  );
  return (
    <div className="w-full overflow-hidden bg-[#F9F9F9]">
      <HomeHeader headerColor={"#F9F9F9"} textColor={"#021744"} />
      <div ref={riteCharleeRef} className="riteCharlee-page">
        <RiteCharleeHero />
      </div>
      <FooterBanner />
      <Footer />
    </div>
  );
};
